
import { Component, Vue, Prop } from 'vue-property-decorator'

Vue.prototype.$multiwatch = function (props, watcher) {
  var iterator = function (prop) {
    this.$watch(prop, watcher)
  }
  props.forEach(iterator, this)
}

const FreeSpeakingConfigModalProps = Vue.extend({
  props: {
    canCancel: Boolean,
    close: Boolean
  }
})

@Component
export default class FreeSpeakingConfigModal extends FreeSpeakingConfigModalProps {
  // @Prop(Boolean) close: boolean | false
  data () {
    return {
      isLoading: false,
      audioTest: true,
      audioDevices: [],
      selectedAudioDeviceId: null,
      userMediaStream: null,
      sampleMediaStream: null,
      sampleAudioContext: null,
      outputAudioContext: null,
      testAudioEl: null,
      threshold: 10,
      analyser: null,
      micAverage: 0,
      thresholdEl: null,
      audioSource: null
    }
  }

  get isComponentModalActive () {
    return this.close
  }

  created () {
    this.$multiwatch(['selectedAudioDeviceId'], function () {
      this.updateAudio()
    })
    this.$multiwatch(['audioTest'], async function () {
      this.updateAudio()
    })
    this.$multiwatch(['close'], function () {
      if (this.isComponentModalActive) {
        this.updateDeviceList()
      }
    })
  }

  mounted () {
    this.fillVariables()
    this.testAudioEl = new Audio()
    this.outputAudioContext = new (window.AudioContext || window.webkitAudioContext)()
    this.sampleAudioContext = new (window.AudioContext || window.webkitAudioContext)()
    this.sampleMediaStream = this.sampleAudioContext.createMediaStreamDestination()
    navigator.mediaDevices.ondevicechange = (event) => {
      this.updateDeviceList()
    }
    if (this.isComponentModalActive) {
      this.updateDeviceList()
    }
  }

  updated () {
    // this.init()
  }

  fillVariables () {
    var container = document.getElementById('thresholdContainer')
    this.thresholdEl = container?.querySelector('.b-slider-fill')
    if (!this.thresholdEl) {
      setTimeout(this.fillVariables, 1000)
    }
  }

  async updateDeviceList (needsToSaveConfig) {
    try {
      if (!this.userMediaStream) {
        try {
          this.userMediaStream = await navigator.mediaDevices.getUserMedia({ audio: true, video: true })
        } catch (e) {
          this.userMediaStream = new MediaStream([])
        }
      } else {
        try {
          var userMedia = await navigator.mediaDevices.getUserMedia({ audio: true, video: true })
          var newTracksList = userMedia.getTracks()
          var existingTracksList = this.userMediaStream.getTracks()
          newTracksList.forEach(track => {
            if (existingTracksList.findIndex(e => e.label === track.label) === -1) {
              this.userMediaStream.addTrack(track)
            }
          })
          existingTracksList.forEach(existingTrack => {
            if (newTracksList.findIndex(e => e.label === existingTrack.label) === -1) {
              this.userMediaStream.removeTrack(existingTrack)
            }
          })
        } catch (e) {
          this.userMediaStream = new MediaStream([])
        }
      }
      needsToSaveConfig = await this.updateAudioDevices() || needsToSaveConfig
      if (needsToSaveConfig) {
        this.saveConfig(false)
      }
    } catch (e) {
      console.error(e)
    }
  }

  async updateAudio () {
    if (this.audioTest) {
      this.connectAudioInput()
      if (!this.audioSource) {
        this.initMicAnalyser()
      }
      this.connectMicAnalyser()
    } else {
      this.testAudioEl.pause()
      this.disconnectMicAnalyser()
    }
  }

  async updateAudioDevices () {
    this.audioDevices = this.userMediaStream.getAudioTracks()
    // this.audioDevices = this.audioDevices.concat([this.sampleMediaStream.stream.getAudioTracks()[0]])
    var needsToSaveConfig = false
    var foundIdx = this.audioDevices.findIndex(e => e.id === this.selectedAudioDeviceId)
    if (foundIdx === -1) {
      this.selectedAudioDeviceId = null
      needsToSaveConfig = true
    }
    if (this.selectedAudioDeviceId === null && this.audioDevices.length > 0) {
      this.selectedAudioDeviceId = this.audioDevices[0].id
      // needsToSaveConfig = true
    }
    return needsToSaveConfig
  }

  connectAudioInput () {
    var idx = this.audioDevices.findIndex(item => item.id === this.selectedAudioDeviceId)
    if (idx > -1) {
      this.audioStream = new MediaStream([this.audioDevices[idx]])
      this.testAudioEl.srcObject = this.audioStream
      this.testAudioEl.play()
    }
  }

  saveConfig (closeModal) {
    var idx = this.audioDevices.findIndex(item => item.id === this.selectedAudioDeviceId)
    if (idx > -1) {
      this.$emit('selectedAudioDeviceTrack', this.audioDevices[idx])
    } else {
      this.$emit('selectedAudioDeviceTrack', null)
      // closeModal = false
    }
    if (closeModal) {
      this.audioTest = false
      this.$emit('close')
    }
  }

  async initMicAnalyser (audioTrack) {
    var audioContext = new AudioContext() // or webkitAudioContext
    this.audioSource = audioContext.createMediaStreamSource(this.audioStream)
    this.javascriptNode = audioContext.createScriptProcessor(2048, 1, 1) // TODO: this will be deprecated soon. should be replaced by AudioWorkletNode:
    this.analyser = audioContext.createAnalyser()
    this.analyser.smoothingTimeConstant = 0.3
    this.analyser.fftSize = 1024
    this.javascriptNode.onaudioprocess = this.audioAnalizerProcessor
  }

  async connectMicAnalyser () {
    this.audioSource.connect(this.analyser)
    this.analyser.connect(this.javascriptNode)
  }

  async disconnectMicAnalyser () {
    try {
      this.audioSource.disconnect(this.analyser)
      this.analyser.disconnect(this.javascriptNode)
      setTimeout(() => { this.thresholdEl.style.width = '0%'; this.micAverage = 0 }, 100)
    } catch (e) {
      console.log('analyser is already disconnected')
    }
  }

  audioAnalizerProcessor () {
    var array = new Uint8Array(this.analyser.frequencyBinCount)
    this.analyser.getByteFrequencyData(array)
    var values = 0

    var length = array.length
    for (var i = 0; i < length; i++) {
      values += array[i]
    }
    var newValue = values / length
    if (newValue > this.threshold && this.micAverage < this.threshold) {
      this.micAverage = (this.micAverage + newValue) / 2
    } else {
      this.micAverage = (this.micAverage * 9 + newValue) / 10
    }
    this.thresholdEl.style.width = `${this.micAverage}%`
  }
}
